import Documentation from './styled';

export default Documentation;
